<div class="expressao-container">
    <div class="expressao-chips">
        @for (item of itens; track $index) {
        @if (item.token.tipo === FormulaTokenTipoEnum.Variavel) {
        <span class="status-badge badge-variavel" [ngClass]="item.badgeClass" [attr.data-chave]="item.chave">
            @if (item.isParametro) {
            <span class="material-symbols-outlined" aria-label="Parâmetro de configuração" title="Parâmetro de configuração">settings</span>
            }
            @if (item.possuiFormulaAplicavel) {
            <span class="material-symbols-outlined" aria-label="Possui fórmula aplicável" title="Possui fórmula aplicável">function</span>
            }
            <span class="variavel-badge-descricao">{{ item.nome }}</span>
            <span class="variavel-badge-nome">{{ '{' + item.nomeVariavel + '}' }}</span>
        </span>
        } @else {
        <span class="status-badge" [ngClass]="item.badgeClass">{{ item.token.display }}</span>
        }
        }
    </div>
</div>
